import { Service } from 'vue-di-container';
import AxiosService from './AxiosService';

@Service()
export default class RecaptchaService {
  private isRecaptchaEnabled: boolean = false;
  private recaptchaKey: string = '';
  private inItialized: boolean = false;
  public async key(): Promise<string> {
    if (!this.inItialized) {
      await this.fillConfig();
    }
    return this.recaptchaKey;
  }
  public async isEnabled(): Promise<boolean> {
    if (!this.inItialized) {
      await this.fillConfig();
    }
    return this.isRecaptchaEnabled;
  }
  private async fillConfig() {
    const axios = new AxiosService();
    const result = await axios.axiosInstance.get('api/cnf');
    this.isRecaptchaEnabled = result.data.Recaptcha.Enabled;
    this.recaptchaKey = result.data.Recaptcha.Key;
    this.inItialized = true;
  }
}
